import React, { PropsWithChildren, createContext, useContext } from 'react';
import { useUserMenu as useUserMenuOrigin } from '../hooks/useUserMenu';

const MenuContext = createContext<any>(null);

function MenuProvider({ children }: PropsWithChildren) {
  const menu = useUserMenuOrigin(); // 여기서만 실제 fetch/useEffect 실행
  return <MenuContext.Provider value={menu}>{children}</MenuContext.Provider>;
}

export default MenuProvider;

export const useMenu = () => useContext(MenuContext);
